export const defaultFragmentShader = `
    precision mediump float;
    
    varying vec2 v_texcoord;
    
    uniform float u_intensity;
    uniform float u_progress;
    uniform sampler2D u_texture;
    
    void main() {
        gl_FragColor = texture2D(u_texture, v_texcoord);
    }
`

export const defaultVertexShader = `
    attribute vec4 a_position;
    attribute vec2 a_texcoord;
    
    uniform mat4 u_matrix;
    uniform mat4 u_texmatrix;
    
    varying vec2 v_texcoord;
    
    void main() {
        gl_Position = u_matrix * a_position;
        v_texcoord = (u_texmatrix * vec4(a_texcoord, 0, 1)).xy;
    }
`

export const defaultShaderSource = {
    fragment: defaultFragmentShader,
    vertex: defaultVertexShader,
}
